import React from 'react';
import { useMediaQuery } from '@/src/shared/hooks/utils/useMediaQuery';

import { Graphic } from './Graphic';
import FindUS from '../FindUS';
import styles from './IntroductionSection.module.scss';

export function IntroductionSection() {
  const isLgDown = useMediaQuery('(max-width:950px)');
  return (
    <section className={styles.container}>
      <div className={styles.leftSection}>
        <h1 className={styles.title}>
          Ask <span>Anything</span>
          <br />
          Anytime, Anywhere
        </h1>
        <p className={styles.text}>
          If you have any questions, just reach out to us and we’ll respond as
          soon as we can. Please provide as much information as possible.
        </p>

        {isLgDown && <Graphic size="small" />}

        <div className={styles.formWrapper}>
          <FindUS />
        </div>
      </div>
      <div className={styles.rightSection}>
        {!isLgDown && <Graphic />}
        <div className={styles.background} />
      </div>
    </section>
  );
}
